import React from 'react'
import Modal, {
  ModalProps,
  ActionModalButtonProps,
  ActionModalButton,
} from '../modal'
import { Icon, Text } from '../../elementals'
import _ from 'lodash'
import type { AutomationTarget, SlottableComponent } from '../../../types'
import { useBreakpoints } from '../../../hooks'

export interface ConfirmationModalProps
  extends ModalProps,
    AutomationTarget,
    SlottableComponent<'actions'> {
  onClose: () => void
  actionInfoText?: string
  cancelButtonProps?: ActionModalButtonProps
  confirmButtonProps?: ActionModalButtonProps
  hideCancelButton?: boolean
  hideCloseButton?: boolean
  onCancel?: () => void
  onConfirm?: () => void
}

const ConfirmationModal = ({
  title,
  children,
  actionInfoText,
  elmId = 'confirmation_modal',
  size = 'tiny',
  hideCancelButton,
  hideCloseButton: hideCloseButtonProp = false,
  confirmButtonProps,
  cancelButtonProps,
  onConfirm,
  onClose,
  onCancel,
  slots,
  ...rest
}: ConfirmationModalProps) => {
  const isMobile = useBreakpoints() === 'mobile'
  const hideCloseButton = hideCloseButtonProp || (isMobile && !hideCancelButton)
  return (
    <Modal
      {...rest}
      title={title}
      elmId={elmId}
      closeIcon={
        hideCloseButton ? (
          <></>
        ) : (
          <Icon
            className='close'
            data-elm-id={`${elmId}_close_button`}
            name='times'
            iconStyle='regular'
            fitted
            onClick={onClose}
          />
        )
      }
      size={size}
    >
      <Modal.Content>
        {typeof children === 'string' ? (
          <Text.Body>{children}</Text.Body>
        ) : (
          children
        )}
      </Modal.Content>
      <Modal.Actions>
        {slots?.actions?.()}
        {actionInfoText && (
          <Text as='span' size='mini'>
            {actionInfoText}
          </Text>
        )}
        {!hideCancelButton && (
          <ActionModalButton
            label={cancelButtonProps?.label || 'Cancel'}
            onClick={cancelButtonProps?.onClick || onCancel || onClose}
            elmId={`${elmId}_cancel_action_btn`}
            {..._.omit(cancelButtonProps, 'onClick', 'label')}
          />
        )}
        <ActionModalButton
          role={confirmButtonProps?.role || 'primary'}
          label={confirmButtonProps?.label || 'Confirm'}
          style={{ marginLeft: '.75em' }}
          onClick={confirmButtonProps?.onClick || onConfirm}
          elmId={`${elmId}_confirm_action_btn`}
          {..._.omit(confirmButtonProps, 'onClick', 'role', 'label')}
        />
      </Modal.Actions>
    </Modal>
  )
}

export default ConfirmationModal
